import React from "react";
import "../../CSS/Industries.css";

function RealEstate() {
    return (
        <>
            
            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">

                    <div className="industry-detail-hero-content">



                        <h1>
                            Solutions for Real Estate
                        </h1>

                        <p style={{ color: '#FF7D37' }}>
                            Digital solutions for property businesses,
                            real estate agencies, developers, and property
                            management organizations.
                        </p>

                    </div>

                </div>
            </section>


            <section className="industry-detail-section">

                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">


                            <h2>
                                Smarter Digital Solutions for Property Businesses
                            </h2>

                            <p>
                                Real estate businesses need effective ways to
                                manage properties, customers, listings,
                                inquiries, and business operations.
                            </p>

                            <p>
                                We develop websites, property applications,
                                management systems, and customized digital
                                solutions.
                            </p>

                        </div>

                        <div className="col-lg-6">

                            <img
                                src="/images/home/real-estate.png"
                                alt="Real Estate Technology Solutions"
                                className="industry-detail-image"
                            />

                        </div>

                    </div>

                </div>

            </section>


            <section className="industry-features">

                <div className="container">

                    <div className="section-heading text-center">

                        <h2>Technology for<br /> Real Estate</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-buildings"></i>
                            <h3>Property Management</h3>
                            <p>Digital systems for managing property information.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-house"></i>
                            <h3>Property Websites</h3>
                            <p>Professional websites for property businesses.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-person-lines-fill"></i>
                            <h3>Lead Management</h3>
                            <p>Manage customer inquiries and property leads efficiently.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-search"></i>
                            <h3>Property Search</h3>
                            <p>Search and listing solutions for property platforms.</p>
                        </div>

                    </div>

                </div>

            </section>

        </>
    );
}

export default RealEstate;